import { useAuth } from '@/context/AuthContext';
import {
  LogoutOutlined,
  UserOutlined,
  TeamOutlined,
  BankOutlined,
  TagsOutlined,
  DollarOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { Avatar, Dropdown, MenuProps, Space, Typography, theme } from 'antd';
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const { Text } = Typography;

export const ProfileDropDown = () => {
  const { user, logout, userRole, userEmail } = useAuth();
  const { token } = theme.useToken();

  const isOwner = userRole === 'OWNER';

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Group menu items by category
  const menuItems: MenuProps['items'] = [
    {
      key: 'userInfo',
      label: (
        <div
          style={{
            padding: '8px 0',
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
          }}
        >
          <Text strong style={{ fontSize: '14px' }}>
            {user.username}
          </Text>
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {user.role || 'User'}
            </Text>
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: '8px' }}>
              {userEmail}
            </Text>
          </div>
        </div>
      ),
      type: 'group',
    },
    {
      type: 'group',
      label: (
        <Text type="secondary" style={{ fontSize: '12px', padding: '0 8px' }}>
          Account
        </Text>
      ),
      children: [
        {
          key: 'profile',
          label: <Link to="/dashboard/profile">Profile</Link>,
          icon: <UserOutlined />,
        },
        // {
        //   key: "accountAccess",
        //   label: <Link to="/dashboard/account-access">Account Access</Link>,
        //   icon: <SettingOutlined />,
        // },
           // conditionally render User Management
      ...(isOwner
        ? [
            {
              key: 'userManagement',
              label: <Link to="/dashboard/user-management">User Management</Link>,
              icon: <TeamOutlined />,
            },
          ]
        : []),
        {
          key: 'accounts',
          label: <Link to="/dashboard/accounts">Accounts</Link>,
          icon: <BankOutlined />,
        },
      ],
    },
    {
      type: 'group',
      label: (
        <Text type="secondary" style={{ fontSize: '12px', padding: '0 8px' }}>
          Data Management
        </Text>
      ),
      children: [
        {
          key: 'asinCategorization',
          label: (
            <Link to="/dashboard/asin-categorization">ASIN Categorization</Link>
          ),
          icon: <TagsOutlined />,
        },
        // {
        //   key: "textCategorization",
        //   label: (
        //     <Link to="/dashboard/text-categorization">Text Categorization</Link>
        //   ),
        //   icon: <FileTextOutlined />,
        // },
        // {
        //   key: "blacklistKeywords",
        //   label: (
        //     <Link to="/dashboard/blacklist-keywords">Blacklist Keywords</Link>
        //   ),
        //   icon: <StopOutlined />,
        // },
      ],
    },
    {
      type: 'group',
      label: (
        <Text type="secondary" style={{ fontSize: '12px', padding: '0 8px' }}>
          Business
        </Text>
      ),
      children: [
        {
          key: 'billing',
          label: <Link to="/dashboard/profile/billing">Billing</Link>,
          icon: <DollarOutlined />,
        },
      ],
    },
    {
      type: 'group',
      label: (
        <Text type="secondary" style={{ fontSize: '12px', padding: '0 8px' }}>
          Legal & Policies
        </Text>
      ),
      children: [
        {
          key: 'termsAndServices',
          label: (
            <Link to="/dashboard/profile/terms-and-services">
              Terms & Services
            </Link>
          ),
          icon: <FileTextOutlined />,
        },
        {
          key: 'privacyPolicy',
          label: (
            <Link to="/dashboard/profile/privacy-policy">Privacy Policy</Link>
          ),
          icon: <FileTextOutlined />,
        },
        {
          key: 'refundPolicy',
          label: (
            <Link to="/dashboard/profile/refund-and-cancellation">
              Refund and Cancellation Policy
            </Link>
          ),
          icon: <DollarOutlined />,
        },
      ],
    },
    {
      type: 'divider',
      style: { margin: '4px 0' },
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: logout,
      style: { color: token.colorErrorText },
    },
  ];

  return (
    <Dropdown
      menu={{
        items: menuItems,
      }}
      trigger={['click']}
      placement="bottomRight"
      arrow
      popupRender={(menu) => (
        <div style={{ minWidth: 240 }}>{menu}</div> // Increase minWidth as needed
      )}
    >
      <div style={{ cursor: 'pointer' }}>
        <Space>
          <Avatar
            style={{
              backgroundColor: token.colorPrimaryBg,
              color: token.colorPrimary,
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            {user.username[0].toUpperCase()}{' '}
          </Avatar>
        </Space>
      </div>
    </Dropdown>
  );
};
    // {
    //   type: 'group',
    //   label: (
    //     <Text type="secondary" style={{ fontSize: '12px', padding: '0 8px' }}>
    //       Legal & Policies
    //     </Text>
    //   ),
    //   children: [
    //     {
    //       key: 'termsAndServices',
    //       label: (
    //         <Link to="/dashboard/profile/terms-and-services">
    //           Terms & Services
    //         </Link>
    //       ),
    //       icon: <FileTextOutlined />,
    //     },
    //     {
    //       key: 'privacyPolicy',
    //       label: (
    //         <Link to="/dashboard/profile/privacy-policy">Privacy Policy</Link>
    //       ),
    //       icon: <FileTextOutlined />,
    //     },
    //     {
    //       key: 'refundPolicy',
    //       label: (
    //         <Link to="/dashboard/profile/refund-and-cancellation">
    //           Refund and Cancellation Policy
    //         </Link>
    //       ),
    //       icon: <DollarOutlined />,
    //     },
    //   ],
    // },

    // {
    //   type: 'divider',
    //   style: { margin: '4px 0' },
    // },
    // {
    //   key: 'logout',
    //   label: 'Logout',
    //   icon: <LogoutOutlined />,
    //   onClick: logout,
    //   style: { color: token.colorErrorText },
    // },
  